import React from "react";
import { motion } from "framer-motion";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion";
import { useLanguage } from "../i18n";

export const Faq = () => {
  const { t } = useLanguage();
  const f = t.faq;
  return (
    <section data-testid="home-faq" className="py-20 lg:py-28 bg-sand">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <motion.div className="text-center" initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }}>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-amberdark mb-6">{f.overline}</p>
          <h2 className="font-display text-4xl sm:text-5xl font-medium tracking-tight leading-tight text-ink">{f.title}</h2>
        </motion.div>
        <Accordion type="single" collapsible className="mt-12 border-t border-ink/15">
          {f.items.map((item, i) => (
            <AccordionItem key={item.q} value={`faq-${i}`} data-testid={`home-faq-${i}`} className="border-ink/15">
              <AccordionTrigger className="py-5 text-left text-xs sm:text-sm uppercase tracking-[0.15em] font-semibold text-ink hover:no-underline">{item.q}</AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-inksoft">{item.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
